/* ================================================
   LYN'S FURNITURE MIAMI — THEME JS
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- CART ICON — force navigation ---- */
  const cartLink = document.querySelector('a.cart-icon');
  if (cartLink) {
    cartLink.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      window.location.href = '/cart';
    });
  }

  /* ---- MOBILE MENU ---- */
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (mobileBtn && mobileNav) {
    mobileBtn.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      mobileBtn.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
      mobileBtn.classList.toggle('active', open);
    });
    document.addEventListener('click', function (e) {
      if (!mobileBtn.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('open');
        mobileBtn.setAttribute('aria-expanded', false);
        mobileNav.setAttribute('aria-hidden', true);
        mobileBtn.classList.remove('active');
      }
    });
  }

  /* ---- SHOP DROPDOWN ---- */
  const dropdownWrap = document.querySelector('.nav-dropdown-wrap');
  const dropdownTrigger = document.querySelector('.nav-dropdown-trigger');
  const megaMenu = document.querySelector('.nav-mega-menu');

  if (dropdownTrigger && megaMenu && dropdownWrap) {

    function openMenu() {
  const triggerRect = dropdownTrigger.getBoundingClientRect();
  const menuWidth = Math.min(window.innerWidth * 0.95, 1400);
  const centerX = triggerRect.left + (triggerRect.width / 2);
  const leftPos = centerX - (menuWidth / 2) - 180;
  const clampedLeft = Math.max(12, Math.min(leftPos, window.innerWidth - menuWidth - 12));

  megaMenu.style.position = 'fixed';
  megaMenu.style.top = (triggerRect.bottom - 12) + 'px';
  megaMenu.style.left = clampedLeft + 'px';
  megaMenu.style.transform = 'none';
  megaMenu.style.width = menuWidth + 'px';
  megaMenu.style.opacity = '1';
  megaMenu.style.visibility = 'visible';
  megaMenu.style.pointerEvents = 'all';
  megaMenu.style.display = 'block';
  dropdownTrigger.classList.add('active');
}

    function closeMenu() {
  megaMenu.style.opacity = '0';
  megaMenu.style.visibility = 'hidden';
  megaMenu.style.pointerEvents = 'none';
  megaMenu.style.display = 'none';
  dropdownTrigger.classList.remove('active');
}

    // Open on hover
    dropdownWrap.addEventListener('mouseenter', openMenu);

    // Open/close on click
    dropdownTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      megaMenu.style.display === 'block' ? closeMenu() : openMenu();
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!dropdownWrap.contains(e.target)) closeMenu();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---- MOBILE SHOP DROPDOWN ---- */
  const mobileToggle = document.querySelector('.mobile-nav__toggle');
  const mobileSub = document.querySelector('.mobile-nav__sub');
  if (mobileToggle && mobileSub) {
    mobileToggle.addEventListener('click', function () {
      const open = mobileSub.classList.toggle('open');
      mobileToggle.classList.toggle('open', open);
    });
  }

  /* ---- ADD TO CART (product card forms) ---- */
  document.querySelectorAll('.product-card form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('button[type=submit]');
      const formData = new FormData(form);
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(function () {
          btn.textContent = 'Added ✓';
          btn.style.background = '#16a34a';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
            updateCartCount();
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = originalText; }, 2000);
        });
    });
  });

  /* ---- CART COUNT UPDATE ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function (cart) {
        const badge = document.querySelector('.cart-badge');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  /* ---- PRODUCT PAGE: QTY BUTTONS ---- */
  const qtyInput = document.querySelector('.qty-input');
  const qtyMinus = document.querySelector('.qty-minus');
  const qtyPlus = document.querySelector('.qty-plus');
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      const val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }

  /* ---- PRODUCT PAGE: IMAGE THUMBNAILS ---- */
  const mainImg = document.querySelector('.product-page__main-img');
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = thumb.dataset.src || thumb.src.replace('120x120', '800x800').replace('_120x120', '_800x800');
        mainImg.style.opacity = '0';
        setTimeout(function () { mainImg.style.opacity = '1'; }, 50);
      }
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ---- PRODUCT PAGE: VARIANT SELECTOR ---- */
  const variantSelect = document.querySelector('#variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const available = !selectedOption.disabled;
      const atcBtn = document.querySelector('.product-page__atc');
      if (atcBtn) {
        if (available) {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          atcBtn.classList.remove('product-page__atc--disabled');
        } else {
          atcBtn.textContent = 'Sold Out';
          atcBtn.disabled = true;
          atcBtn.classList.add('product-page__atc--disabled');
        }
      }
    });
  }

  /* ---- PRODUCT PAGE: ADD TO CART ---- */
  const productForm = document.querySelector('.product-page form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = productForm.querySelector('.product-page__atc');
      const formData = new FormData(productForm);
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(function () {
          btn.textContent = 'Added to Cart ✓';
          btn.style.background = '#16a34a';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
            updateCartCount();
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error — please try again';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = originalText; }, 2500);
        });
    });
  }

  /* ---- ANNOUNCEMENT BAR CLOSE ---- */
  const announceClose = document.querySelector('.announcement-bar__close');
  const announceBar = document.querySelector('.announcement-bar');
  if (announceClose && announceBar) {
    announceClose.addEventListener('click', function () {
      announceBar.style.display = 'none';
      sessionStorage.setItem('announcementClosed', 'true');
    });
    if (sessionStorage.getItem('announcementClosed')) {
      announceBar.style.display = 'none';
    }
  }

  /* ---- SMOOTH SCROLL for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- HEADER SCROLL SHADOW ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- LAZY LOAD images ---- */
  if ('IntersectionObserver' in window) {
    const lazyImgs = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('loaded');
          observer.unobserve(entry.target);
        }
      });
    });
    lazyImgs.forEach(function (img) { observer.observe(img); });
  }

  /* ---- COLLECTION SORT ---- */
  const sortSelect = document.querySelector('#sort-by');
  if (sortSelect) {
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;
  }

});